import React from 'react';
import { Phone, Clock, CheckCircle2, ChevronRight, Award } from 'lucide-react';
import { Button } from '../ui/button';
import { companyInfo } from '../../mock';
import { scrollToSection } from './scroll';

export const Hero = () => (
      <section className="relative pt-16 overflow-hidden bg-gradient-to-br from-gray-900 via-gray-800 to-black min-h-screen flex items-center">
        {/* Animated Background Effects */}
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full bg-yellow-400/10 blur-3xl animate-pulse"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 rounded-full bg-yellow-400/10 blur-3xl animate-pulse"></div>
        </div>
        <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-32">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
                Brooklyn Electrician
                <span className="block text-yellow-400">24/7 Emergency &amp; Same-Day Service</span>
              </h1>
              <p className="text-lg text-gray-300">
                Jetco Electrical has served Brooklyn homes and businesses for 15+ years. We are insured and BBB-accredited, and we answer the phone day and night, so a power problem never has to wait until morning.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button 
                  size="lg" 
                  className="bg-yellow-400 hover:bg-yellow-500 text-black font-bold shadow-lg"
                  onClick={() => scrollToSection('contact')}
                >
                  Get Free Estimate
                  <ChevronRight className="w-5 h-5 ml-2" />
                </Button>
                <a href={`tel:${companyInfo.phone}`}>
                  <Button size="lg" variant="outline" className="w-full sm:w-auto border-2 border-cyan-400 text-cyan-400 hover:bg-cyan-400 hover:text-black">
                    <Phone className="w-5 h-5 mr-2" />
                    {companyInfo.phone}
                  </Button>
                </a>
              </div>
              <div className="flex flex-wrap items-center gap-4 pt-4">
                <div className="flex items-center space-x-2 bg-yellow-400/20 border border-yellow-400/50 rounded-full px-4 py-2">
                  <Clock className="w-5 h-5 text-yellow-400" />
                  <span className="text-sm font-medium text-white">24/7 Emergency Service</span>
                </div>
                <div className="flex items-center space-x-2 bg-cyan-400/20 border border-cyan-400/50 rounded-full px-4 py-2">
                  <CheckCircle2 className="w-5 h-5 text-cyan-400" />
                  <span className="text-sm font-medium text-white">Same-Day Service</span>
                </div>
              </div>
            </div>
            <div className="relative">
              <div className="aspect-square rounded-2xl overflow-hidden shadow-2xl border-2 border-yellow-400/30">
                <img 
                  src="https://images.pexels.com/photos/257736/pexels-photo-257736.jpeg" 
                  alt="Professional Electrical Work"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -left-6 bg-gray-900 border border-yellow-400/50 rounded-xl shadow-xl p-6 max-w-xs">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-yellow-400 rounded-lg flex items-center justify-center">
                    <Award className="w-6 h-6 text-black" />
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-white">15+</p>
                    <p className="text-sm text-gray-400">Years Experience</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
);
